export default [
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4AK6F7OLvEQ5QYCBNiQWHq'
          },
          href: 'https://api.spotify.com/v1/artists/4AK6F7OLvEQ5QYCBNiQWHq',
          id: '4AK6F7OLvEQ5QYCBNiQWHq',
          name: 'One Direction',
          type: 'artist',
          uri: 'spotify:artist:4AK6F7OLvEQ5QYCBNiQWHq'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7p1fX8aUySrBdx4WSYspOu'
      },
      href: 'https://api.spotify.com/v1/albums/7p1fX8aUySrBdx4WSYspOu',
      id: '7p1fX8aUySrBdx4WSYspOu',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/fa3dd6a5fab74f40b020da009825209c807213d3',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/02618ee3e7565e9012c5fedb35c1b36eedbbcd3d',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/e7cc8fe75b8beee36d0f3235a61faf074e6fe0ce',
          width: 64
        }
      ],
      name: 'Midnight Memories (Deluxe)',
      type: 'album',
      uri: 'spotify:album:7p1fX8aUySrBdx4WSYspOu'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4AK6F7OLvEQ5QYCBNiQWHq'
        },
        href: 'https://api.spotify.com/v1/artists/4AK6F7OLvEQ5QYCBNiQWHq',
        id: '4AK6F7OLvEQ5QYCBNiQWHq',
        name: 'One Direction',
        type: 'artist',
        uri: 'spotify:artist:4AK6F7OLvEQ5QYCBNiQWHq'
      }
    ],
    disc_number: 1,
    duration_ms: 245493,
    explicit: false,
    external_ids: {
      isrc: 'GBHMU1300210'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4nVBt6MZDDP6tRVdQTgxJg'
    },
    href: 'https://api.spotify.com/v1/tracks/4nVBt6MZDDP6tRVdQTgxJg',
    id: '4nVBt6MZDDP6tRVdQTgxJg',
    is_playable: true,
    name: 'Story of My Life',
    popularity: 75,
    preview_url:
      'https://p.scdn.co/mp3-preview/e8cbef539a2a32def5e66968cc00769a4f523c1c?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:4nVBt6MZDDP6tRVdQTgxJg'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/6oMuImdp5ZcFhWP0ESe6mG'
          },
          href: 'https://api.spotify.com/v1/artists/6oMuImdp5ZcFhWP0ESe6mG',
          id: '6oMuImdp5ZcFhWP0ESe6mG',
          name: 'Migos',
          type: 'artist',
          uri: 'spotify:artist:6oMuImdp5ZcFhWP0ESe6mG'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7fd7SEK25VS3gJAUgSwL6y'
      },
      href: 'https://api.spotify.com/v1/albums/7fd7SEK25VS3gJAUgSwL6y',
      id: '7fd7SEK25VS3gJAUgSwL6y',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/79ef8fb6e772a47e3e045a747376dca7b900583e',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/dfc7c4f6f238bdd64f37c707e82a9b91cf3a0910',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/201f4f292e8b418759f811bed70b69855ac69960',
          width: 64
        }
      ],
      name: 'Culture II',
      type: 'album',
      uri: 'spotify:album:7fd7SEK25VS3gJAUgSwL6y'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6oMuImdp5ZcFhWP0ESe6mG'
        },
        href: 'https://api.spotify.com/v1/artists/6oMuImdp5ZcFhWP0ESe6mG',
        id: '6oMuImdp5ZcFhWP0ESe6mG',
        name: 'Migos',
        type: 'artist',
        uri: 'spotify:artist:6oMuImdp5ZcFhWP0ESe6mG'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh'
        },
        href: 'https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh',
        id: '0hCNtLu0JehylgoiP8L4Gh',
        name: 'Nicki Minaj',
        type: 'artist',
        uri: 'spotify:artist:0hCNtLu0JehylgoiP8L4Gh'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4kYSro6naA4h99UJvo89HB'
        },
        href: 'https://api.spotify.com/v1/artists/4kYSro6naA4h99UJvo89HB',
        id: '4kYSro6naA4h99UJvo89HB',
        name: 'Cardi B',
        type: 'artist',
        uri: 'spotify:artist:4kYSro6naA4h99UJvo89HB'
      }
    ],
    disc_number: 1,
    duration_ms: 303076,
    explicit: true,
    external_ids: {
      isrc: 'USUM71712002'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4wFjTWCunQFKtukqrNijEt'
    },
    href: 'https://api.spotify.com/v1/tracks/4wFjTWCunQFKtukqrNijEt',
    id: '4wFjTWCunQFKtukqrNijEt',
    is_playable: true,
    name: 'MotorSport',
    popularity: 81,
    preview_url: null,
    track_number: 17,
    type: 'track',
    uri: 'spotify:track:4wFjTWCunQFKtukqrNijEt'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/76M2Ekj8bG8W7X2nbx2CpF'
          },
          href: 'https://api.spotify.com/v1/artists/76M2Ekj8bG8W7X2nbx2CpF',
          id: '76M2Ekj8bG8W7X2nbx2CpF',
          name: 'NGHTMRE',
          type: 'artist',
          uri: 'spotify:artist:76M2Ekj8bG8W7X2nbx2CpF'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/20DZAfCuP1TKZl5KcY7z3Q'
          },
          href: 'https://api.spotify.com/v1/artists/20DZAfCuP1TKZl5KcY7z3Q',
          id: '20DZAfCuP1TKZl5KcY7z3Q',
          name: 'SLANDER',
          type: 'artist',
          uri: 'spotify:artist:20DZAfCuP1TKZl5KcY7z3Q'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1ABYsJwhqu0MoN3HVn3tKi'
      },
      href: 'https://api.spotify.com/v1/albums/1ABYsJwhqu0MoN3HVn3tKi',
      id: '1ABYsJwhqu0MoN3HVn3tKi',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/c05a08c2b9a69ae433bdb8c8b9c5a68935032d7c',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/037a98e0de6bff2fefec08ce511dc4281bd1d2dc',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/d4e702039e79d1c0ceda1a582e8f72e9cb8cfaad',
          width: 64
        }
      ],
      name: 'GUD VIBRATIONS',
      type: 'album',
      uri: 'spotify:album:1ABYsJwhqu0MoN3HVn3tKi'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/76M2Ekj8bG8W7X2nbx2CpF'
        },
        href: 'https://api.spotify.com/v1/artists/76M2Ekj8bG8W7X2nbx2CpF',
        id: '76M2Ekj8bG8W7X2nbx2CpF',
        name: 'NGHTMRE',
        type: 'artist',
        uri: 'spotify:artist:76M2Ekj8bG8W7X2nbx2CpF'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/20DZAfCuP1TKZl5KcY7z3Q'
        },
        href: 'https://api.spotify.com/v1/artists/20DZAfCuP1TKZl5KcY7z3Q',
        id: '20DZAfCuP1TKZl5KcY7z3Q',
        name: 'SLANDER',
        type: 'artist',
        uri: 'spotify:artist:20DZAfCuP1TKZl5KcY7z3Q'
      }
    ],
    disc_number: 1,
    duration_ms: 224210,
    explicit: false,
    external_ids: {
      isrc: 'USZ4V1600245'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2BVUOGciUUUqOPSLtHwLGp'
    },
    href: 'https://api.spotify.com/v1/tracks/2BVUOGciUUUqOPSLtHwLGp',
    id: '2BVUOGciUUUqOPSLtHwLGp',
    is_playable: true,
    name: 'GUD VIBRATIONS',
    popularity: 62,
    preview_url:
      'https://p.scdn.co/mp3-preview/b29796ac241e6ea2581ad05c10cc49957d3039e5?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:2BVUOGciUUUqOPSLtHwLGp'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/11gWrKZMBsGQWmobv3oNfW'
          },
          href: 'https://api.spotify.com/v1/artists/11gWrKZMBsGQWmobv3oNfW',
          id: '11gWrKZMBsGQWmobv3oNfW',
          name: 'Alison Wonderland',
          type: 'artist',
          uri: 'spotify:artist:11gWrKZMBsGQWmobv3oNfW'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6Jwpxghteb64iHg6ftMnNo'
      },
      href: 'https://api.spotify.com/v1/albums/6Jwpxghteb64iHg6ftMnNo',
      id: '6Jwpxghteb64iHg6ftMnNo',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/7821798baf0204a93b62759ff50db754eac7ac43',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/f4a2ddd7f207e9ac9e3085a2b8b3b6bc990412de',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/c72892118b8126b18c127d14d203ef0bec8dc2a1',
          width: 64
        }
      ],
      name: 'Awake',
      type: 'album',
      uri: 'spotify:album:6Jwpxghteb64iHg6ftMnNo'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/11gWrKZMBsGQWmobv3oNfW'
        },
        href: 'https://api.spotify.com/v1/artists/11gWrKZMBsGQWmobv3oNfW',
        id: '11gWrKZMBsGQWmobv3oNfW',
        name: 'Alison Wonderland',
        type: 'artist',
        uri: 'spotify:artist:11gWrKZMBsGQWmobv3oNfW'
      }
    ],
    disc_number: 1,
    duration_ms: 183912,
    explicit: false,
    external_ids: {
      isrc: 'AUUM71700693'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/6Apozxrk03AIyQwyswUjbt'
    },
    href: 'https://api.spotify.com/v1/tracks/6Apozxrk03AIyQwyswUjbt',
    id: '6Apozxrk03AIyQwyswUjbt',
    is_playable: true,
    name: 'Church',
    popularity: 61,
    preview_url: null,
    track_number: 7,
    type: 'track',
    uri: 'spotify:track:6Apozxrk03AIyQwyswUjbt'
  }
];



// WEBPACK FOOTER //
// ./src/utils/data/favorites.js